/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FuelTransactionHistoryResponsePagination
 */
export interface FuelTransactionHistoryResponsePagination {
    /**
     * Total number of fuel transactions
     * @type {number}
     * @memberof FuelTransactionHistoryResponsePagination
     */
    total?: number;
    /**
     * Number of transactions per page
     * @type {number}
     * @memberof FuelTransactionHistoryResponsePagination
     */
    limit?: number;
    /**
     * Starting offset
     * @type {number}
     * @memberof FuelTransactionHistoryResponsePagination
     */
    offset?: number;
    /**
     * Whether more transactions exist
     * @type {boolean}
     * @memberof FuelTransactionHistoryResponsePagination
     */
    hasMore?: boolean;
}

/**
 * Check if a given object implements the FuelTransactionHistoryResponsePagination interface.
 */
export function instanceOfFuelTransactionHistoryResponsePagination(value: object): value is FuelTransactionHistoryResponsePagination {
    return true;
}

export function FuelTransactionHistoryResponsePaginationFromJSON(json: any): FuelTransactionHistoryResponsePagination {
    return FuelTransactionHistoryResponsePaginationFromJSONTyped(json, false);
}

export function FuelTransactionHistoryResponsePaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelTransactionHistoryResponsePagination {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'] == null ? undefined : json['total'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'offset': json['offset'] == null ? undefined : json['offset'],
        'hasMore': json['hasMore'] == null ? undefined : json['hasMore'],
    };
}

export function FuelTransactionHistoryResponsePaginationToJSON(json: any): FuelTransactionHistoryResponsePagination {
    return FuelTransactionHistoryResponsePaginationToJSONTyped(json, false);
}

export function FuelTransactionHistoryResponsePaginationToJSONTyped(value?: FuelTransactionHistoryResponsePagination | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'limit': value['limit'],
        'offset': value['offset'],
        'hasMore': value['hasMore'],
    };
}

